<template>
  <div class="financeManage-alarmManage-page">
    <p class="hasBottomLine">借贷宝资产预警数据统计</p>
    <!-- <div class="header-seach-box">
      <div class="inputWithSelectBox">
        <el-input placeholder="请输入币名称"  v-model="serchInfo.selectCoin" class="input-with-select">
          <el-button slot="append" disabled @click="getPageListInfo()" icon="el-icon-search">搜索</el-button>
        </el-input>
      </div>
    </div> -->
    <div class="table-box">
      <el-table :data="preceptDataListInfo" border style="width: 99.9%">
        <el-table-column prop="mortgageCoin" label="抵押币种"> </el-table-column>
        <el-table-column prop="totalMortgageAmount" label="累计抵押资产"> </el-table-column>
        <el-table-column prop="borrowCoin" label="借贷币种"> </el-table-column>
        <el-table-column prop="totalBorrowAmount" label="累计借贷资产"> </el-table-column>

        <el-table-column prop="totalInterest" label="已产生利息"> </el-table-column>
        <!-- <el-table-column prop="orderStatus" label="对应订单状态"> </el-table-column> -->
        <el-table-column prop="orderCount" label="订单数量（个）"> </el-table-column>

        <el-table-column prop="mortgageAmount" label="订单风险率范围（%）">
          <template slot-scope="scope">
            <span>{{ scope.row.blastRate * 100 }}%</span>~
            <span>{{ scope.row.warnRate * 100 }}%</span>
          </template>
        </el-table-column>

        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="showListBtn(scope.row)">查看所有订单</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-box">
      <!-- <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="accountListTotal"
      >
      </el-pagination> -->
    </div>

    <el-dialog title="全部订单" class="bk-table-dialog" :visible.sync="orderListDialog">
      <el-table :data="orderListInfo">
        <el-table-column property="id" label="订单编号" width="160"></el-table-column>
        <el-table-column property="mortgageCoin" label="抵押币种" width="160"></el-table-column>
        <el-table-column property="mortgageAmount" label="抵押数量"></el-table-column>
        <el-table-column property="borrowCoin" label="借贷币种"></el-table-column>
        <el-table-column property="borrowAmount" label="借贷数量"></el-table-column>
        <el-table-column property="interestAmount" label="借贷利息"></el-table-column>
        <el-table-column property="riskRate" label="订单风险率（%）" width="200">
           <template slot-scope="scope">
           <span>{{scope.row.riskRate *100}} %</span>
          </template>
        </el-table-column>
        <el-table-column property="address" label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0"> 审核中</span>
            <span v-else-if="scope.row.status == 1"> 贷款中</span>
            <span v-else-if="scope.row.status == 2"> 已完成</span>
            <span v-else-if="scope.row.status == 3"> 已取消</span>
            <span v-else-if="scope.row.status == 4"> 强平中</span>
            <span v-else-if="scope.row.status == 5"> 已强平</span>
          </template>
        </el-table-column>
        <el-table-column prop="maxDay" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="primary" @click="showDetailBtn(scope.row)">订单明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="orderListTotal"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../store";
import api from "../api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "alarmManage",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      orderListDialog: false,
      borrowCoinParam: "",
      mortgageCoinParam: "",
    
    };
  },
  computed: {
    ...mapState("FinanceManage", ["preceptDataListInfo", "orderListInfo", "orderListTotal"])
  },
  methods: {
    ...mapActions("FinanceManage", ["getPreceptDataList", "getOrderList"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    pageChange(val) {
      console.log(`当前页: ${val}`);
      this.getPageListInfo();
    },
    showListBtn(row) {
      let that = this;
      this.orderListDialog = true;
      this.borrowCoinParam = row.borrowCoin;
      this.mortgageCoinParam = row.mortgageCoin;
      this.getPageListInfo();
    },
    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize,
        borrowCoin: this.borrowCoinParam,
        mortgageCoin: this.mortgageCoinParam,
        status: 1
      };
      this.getOrderList(postData);
    },
    handleSearch() {},
    clearForm() {
      this.editDialog = false;
      this.preceptStatusDialog = false;
    },

    showDetailBtn(row) {
      this.toGoDetailPage(row.id)
    },
    toGoDetailPage(id){
        this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id)
    },
  },
  created() {},
  mounted() {
    this.getPreceptDataList();
  }
};
</script>

<style lang="less">
.financeManage-alarmManage-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }

  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }

  .bk-table-dialog {
    .el-dialog {
      width: 70%;
      .el-dialog__header {
        text-align: center;
        color: red;
      }
      .el-dialog__body {
        .el-table {
          .el-table__header-wrapper {
            .el-table__header {
              text-align: center;
              .cell {
                text-align: center;
              }
            }
          }
          .el-table__body-wrapper {
            .cell {
              text-align: center;
            }
          }
        }
      }

      .el-dialog__footer {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
